import palette from 'google-palette';

export const levelColors = palette('tol', 10).map((color) => `#${color}`);

export default {};
